import { h } from 'preact';
import clsx from 'clsx';
import { useEffect, useState, useRef } from 'preact/hooks';
import { useModal } from '../modal-context';
import { useThreekit } from '../threekit-context';

const ThreekitPlayer = () => {
  const { modalName } = useModal();
  const { player, products, getAvailableBackgroundColors, productTag } =
    useThreekit();
  const isPersonalizeOrService =
    productTag === 'cstm:personalization' || productTag === 'cstm:service';
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);

  useEffect(() => {
    const playerEl = document.querySelector('#player');

    if (!playerEl) {
      return;
    }

    ref.current.appendChild(playerEl);
  }, []);

  useEffect(() => {
    const backgroundInfo = products ? getAvailableBackgroundColors() : null;
    if (player && backgroundInfo) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player, products]);

  if (!ref) {
    return null;
  }

  return (
    <div
      className={clsx(
        'relative w-screen flex items-center justify-center transition-all duration-500 ease-in-out',
        loading ? 'bg-bg-1/[0.7] h-screen' : 'h-full',
      )}
    >
      <div
        className={clsx(
          'relative w-screen h-full transition-all duration-500 ease-in-out',
          modalName === 'Help' ? 'opacity-[0.3]' : '',
          loading ? 'bg-bg-1/[0.7]' : '',
          isPersonalizeOrService ? 'top-[-8%]' : 'top-[15%] laptop:top-0',
        )}
        ref={ref}
      />
    </div>
  );
};

export default ThreekitPlayer;
